import { _decorator, Component } from 'cc';
import Lobby from '../../../System/Lobby';

const { ccclass } = _decorator;

@ccclass('JackpotComponent')
export default class JackpotComponent extends Component {
    public onLoad() {
        this.node.active = Lobby.jackpot.isJackpotApplied;
    }
}
